export const faTranslations = {
	'CUSTOMER_PORTAL': 'پورتال مشتریان',
	'PARTNER_PORTAL': 'پورتال نمایندگان',
	'HELLO': 'به پورتال SarvCRM خوش آمدید.',
	'UPLOAD_FILE': 'برای بارگذاری کلیک کنید',
	'FILE_TYPE': 'نوع فایل',
	'PLEASE_WAIT': 'لطفا منتظر بمانید ...',
	'LIST_VIEW' : "لیست",
	'DETAIL_VIEW' : "مشاهده",
	'EDIT' : "ویرایش",
	'CREATE_DUPLICATE' : "ایجاد مشابه",
	'SAVE' : "ذخیره",
	'SAVE_AND_CONTINUE' : "ذخیره و ادامه",
	'NEXT_STEP': 'مرحله بعد',
	'PREV_STEP': 'مرحله قبل',
	'CANCEL' : "لغو",
	'CONFIG' : "تنظیمات",
	'PRIMARY': "اصلی",
	'MOBILE': "همراه",
	'DRAG_HERE': 'فایل خود را اینجا بکشید',
	'OR': 'یا',
	'BROWSE_FILE': 'انتخاب کنید',
	'ATTACHMENT': 'فایل ضمیمه',
	'USER_INFORMATION': 'اطلاعات کاربر',
	'COMMENTS': 'نظرات',
	'SUBMIT_COMMENT': 'ثبت نظر',
	'PDF': 'چاپ با فرمت pdf',
	'RAHKARAN_REPORTS': 'گزارشات راهکاران',
	'PAY': 'پرداخت',
	'CLOSE_TICKET': 'بستن تیکت',
	'UNREAD_NOTIFICATIONS': 'پیام های خوانده نشده',
	'APPROVE': 'تایید',
	'DECLINE': 'رد',
	'NO_DATA': 'اطلاعاتی یافت نشد.',
	'PENDING': 'در انتظار تایید',
	'APPROVED': 'تایید شده',
	'REJECTED': 'رد شده',
	'APPROVAL_STATUS': 'وضعیت تاییدیه',
	'NO_DASHLET': 'هیچ دشلتی جهت نمایش یافت نشد.',
	'READ_ALL_NOTIFICATIONS': 'خواندن همه اعلانات',
	'SEE_MORE' : 'مشاهده بیشتر ...',
	'FAQ': 'سوالات متداول',
	'TOTAL_RESULT': 'تعداد نتایج',
	'FIELD' : 'فیلد',
	'VALUE' : 'مقدار',
	'OPERATOR' : 'عملگر',
	'DOWNLOAD' : 'دانلود',
	'UPLOADING' : 'در حال بارگذاری...',
	'UPLOAD' : 'بارگذاری',
	'UPLOAD_SUCCESSFUL' : 'آپلود با موفقیت انجام شد!',
	'PENDING_TO_GET_URL_FROM_SERVER' : 'در حال دریافت لینک از سرور...',
	'UPLOADING_IN_S3' : 'در حال آپلود به ابرآمد',
	'PROFILE' : {
		'SECURITY_SETTINGS': 'تنظیمات امنیتی',
		'LANGUAGE' : "زبان نرم افزار",
		'THEME' : "قالب صفحه نمایش",
		'NAME': "نام",
		'USERNAME': "نام کاربری",
		'ACCOUNT': "حساب مرتبط",
		'PHONE': "تلفن همراه",
		'EMAIL': "آدرس ایمیل",
		'USER_TYPE': 'نوع کاربر',
		'PARTNER': 'نماینده',
		'CUSTOMER': 'مشتری',
		'CURRENT_PASSWORD': 'رمز عبور فعلی',
		'NEW_PASSWORD': 'رمز عبور جدید',
		'CONFIRM_PASSWORD': 'تکرار رمز عبور',
		'EQUAL_PASSWORD' : 'پسورد ها با هم مطابقت ندارند',
	},
	'FIELDS' : {
		'PART_NUMBER': 'کد محصول',
		'BRAND_NAME': 'برند',
		'PRODUCT_QTY': 'تعداد',
		'PRODUCT_LIST_PRICE': 'قیمت واحد',
		'PRODUCT_NAME': 'نام محصول',
		'QTY': 'تعداد واحد اصلی',
		'UNIT_PRICE': 'مبلغ واحد',
		'DISCOUNT': 'تخفیف',
		'TAX': 'مالیات',
		'TOTAL_PRICE': 'مبلغ کل',
		'GRAND_TOTAL': 'مجموع مبالغ',
		'TOTAL_QTY': 'مجموع تعداد',
		'NAME' : 'نام',
		'TITLE' : 'عنوان',
		'ASSIGNED_USER_NAME' : 'کاربر مسئول',
		'END_DATE' : 'تاریخ خاتمه',
		'STATUS' : 'وضعیت',
		'TYPE' : 'نوع',
		'DESCRIPTION' : 'توضیحات',
		'ITEM_DESCRIPTION' : 'توضیحات',
		'BUNDLE_NAME' : 'بسته محصول',
		'DATE_START' : 'تاریخ شروع',
		'DATE_END' : 'تاریخ خاتمه',
		'PRIMARY_NUMBER_RAW' : 'شماره اصلی',
		'BILLING_ADDRESS_STATE' : 'استان',
		'BILLING_ADDRESS_CITY' : 'شهر',
		'BILLING_ADDRESS_STREET' : 'آدرس',
		'SALES_STAGE' : 'مرحله فروش',
		'DATE_CLOSED' : 'تاریخ خاتمه',
		'AMOUNT' : 'مبلغ',
		'SALUTATION' : 'پسوند',
		'FIRST_NAME' : 'نام',
		'LAST_NAME' : 'نام خانوادگی',
		'NATIONAL_CODE' : 'کد ملی',
		'LEAD_SOURCE' : 'منبع سرنخ',
		'QUOTE_DATE' : 'تاریخ پیش فاکتور',
		'NUMBER' : 'شماره',
		'TOTAL_AMOUNT' : 'مبلغ کل',
		'INVOICE_DATE' : 'تاریخ فاکتور',
		'CASE_NUMBER' : 'شماره سرویس',
		'PURCHASE_ORDER_DATE' : 'تاریخ سفارش',
		'GEOGRAPHICAL': 'منطقه جغرافیایی',
		'COUNTRY': 'کشور',
		'STATE': 'استان',
		'CITY': 'شهر',
		'POSTAL_CODE': 'کدپستی',
		'LOCATION': 'موقعیت جغرافیایی',
		'ADDRESS': 'آدرس',
		'BILLING': 'صورتحساب',
		'SHIPPING': 'ارسال کالا',
		'DISCOUNT_AMOUNT': 'تخفیف',
		'VAT_AMT': 'مالیات',
		'PRODUCT_SECOND_QTY': 'تعداد واحد ثانویه',
		'DATE_MODIFIED': 'تاریخ آخرین تغییر',
	},
	'THEMES' : {
		'DEFAULT' : "پیش فرض",
		'SG' : "سرونو",
		'DARK' : "تیره",
	},
	'LANGUAGES' : {
		'FA' : "فارسی",
		'EN' : "انگلیسی",
	},
	'FILTER' : {
		'DESC' : "نزولی",
		'ASC' : "صعودی",
		'SORT' : "مرتب سازی",
		'SORT_BY' : "مرتب سازی بر اساس",
		'COUNT' : "تعداد",
		'SEARCH' : "جستجو",
		'RESET' : "ریست",
		'DATE_ENTERED' : "تاریخ ایجاد",
		'FROM_DATE' : "از ...",
		'TO_DATE' : "تا ...",
		'ADVANCED_FILTERS' : "فیلتر پیشرفته",
		'NEW_FILTER': 'افزودن فیلتر جدید',
		'FILTER_CLEANER': 'حذف همه فیلترها',
		'SUBMIT_FILTER': 'اعمال فیلتر',
		'SAVE_FILTERS': 'ذخیره همه فیلترها',
	},
	'OPERATORS' : {
		'EQUAL' : "مساوی",
		'NOT_EQUAL' : "مخالف",
		'LIKE' : "شامل عبارت",
		'IN' : "یکی از مقادیر",
		'NOT_IN' : "غیر از مقادیر",
		'GREATER' : "بزرگتر از",
		'GREATER_EQUAL' : "بزرگتر یا مساوی",
		'LESS' : "کوچکتر از",
		'LESS_EQUAL' : "کوچکتر یا مساوی",
		'AFTER' : "بعد از",
		'AFTER_EQUAL' : "بعد یا برابر",
		'BEFORE' : "قبل از",
		'BEFORE_EQUAL' : "قبل یا برابر",
		'DATE_RANGE' : "بازه زمانی",
	},
	'DATE' : {
		'DAY' : "امروز",
		'WEEK' : "7 روز گذشته",
		'MONTH' : "30 روز گذشته", 
		'QUARTER' : "90 روز گذشته", 
		'YEAR' : "365 روز گذشته"
	},
	'ERROR': {
		'PAGE_NOT_FOUND' : "صفحه مورد نظر یافت نشد!",
		'ALREADY_ON_PAGE': 'در حال مشاهده صفحه مورد نظر هستید.',
		'WRONG_EMAIL_ERROR': 'آدرس ایمیل به درستی وارد نشده است!',
		'WRONG_PHONE_NUMBER_ERROR': 'شماره تماس به درستی وارد نشده است!',
		'EMPTY_PHONE_NUMBER_OR_EMAIL_ERROR': 'لطفا شماره تماس و یا آدرس ایمیل را وارد کنید.',
		'WRONG_DATA': 'لطفا اطلاعات خود را به درستی وارد کنید.',
		'WRONG_CONFIRM_CODE': "کد تایید وارد شده اشتباه است!",
		'PASSWORD_AND_REPEATED_PASSWORD_MISMATCHED': "رمز عبور وارد شده و تکرار آن برابر نیستند!",
		'WRONG_NATIONAL_CODE': "کد ملی صحیح نمی باشد",
		'WRONG_POSTAL_CODE': "کدپستی صحیح نمی باشد",
		'IS_NUMERIC': "باید از نوع عدد باشد",
		'IS_REQUIRED': "اجباری است",
		'WRONG_LENGTH': "طول داده ها با معیارهای مورد نیاز مطابقت ندارد",
		'NOTHING_TO_SHOW': "هیچ اطلاعاتی برای نمایش وجود ندارد",
		'DUPLICATE_BILLING_ADDRESS': "آدرس ارسال صورتحساب قبلا ثبت شده است.",
		'DUPLICATE_SHIPPING_ADDRESS': "آدرس ارسال کالا قبلا ثبت شده است.",
		'NON_ACCESSIBLE': "دسترسی لازم جهت نمایش این صفحه وجود ندارد.",
		'DELETE_ALL_LINEITEMS': "همه محصولات انتخاب شده حذف خواهند شد. آیا اطمینان دارید ؟",
		'SELECT_A_FIELD': "یک فیلد را انتخاب نمایید.",
		'INVALID_FILE_FORMAT': "فرمت فایل انتخاب شده صحیح نمی باشد.",
		'ERROR_IN_UPLOAD': "آپلود انجام نشد",
		'ONLY_VIDEO_TYPE_ALLOWED': "فقط فایل‌های ویدیویی مجاز هستند",
		'CHOOSE_A_FILE': "لطفاً یک فایل انتخاب کنید",
	},
	'COMPONENTS' : {
		'ADD_PRODUCT': "انتخاب محصول",
		'ADD_BUNDLE': "انتخاب بسته محصول",
		'OPEN_MODAL' : "باز کردن مودال",
		'DECLINE' : "انصراف",
		'SAVE' : "ذخیره",
		'SELECT_OPTION_PLACEHOLDER': "...",
	},
	'NOTIFICATION' : {
		'COMMENT' : "کامنت جدید",
		'STATUS_CHANGED' : "تغییر رکورد",
		'ASSIGNED_TO' : "اختصاص یافته",
		'NEW_INSERT': "رکورد جدید",
		'APPROVAL': "تاییدیه",
	},
	'AUTHENTICATION': {
		'LOGIN_TO_ACCOUNT': "ورود به حساب کاربری",
		'REGISTER_ACCOUNT': "ایجاد حساب کاربری",
		'FORGOT_PASSWORD': "رمز خود را فراموش کرده ای؟",
		'REMEMBER_ME': "مرا بخاطر بسپار",
		'CELL_PHONE': "شماره تماس",
		'PASSWORD': "گذرواژه",
		'LOGIN': "ورود",
		'SIGN_UP': "ثبت نام",
		'FIRST_NAME': "نام",
		'LAST_NAME': "نام خانوادگی",
		'NATIONAL_CODE' : 'کد ملی',
		'EMAIL': "آدرس ایمیل",
		'CONFIRM_CODE': "کد تایید",
		'CONFIRM': "تایید",
		'RETURN': "بازگشت",
		'INSERT_CONFIRM_CODE': "کد تایید ارسال شده را وارد کنید",
		'FORGOT_PASSWORD_TITLE': "بازیابی رمز عبور",
		'INSERT_USERNAME': "نام کاربری خود را وارد کنید",
		'USERNAME': "نام کاربری",
		'SEND_CONFIRM_CODE': "ارسال کد تایید",
		'INSERT_NEW_PASSWORD': "رمز عبور جدید را وارد کنید",
		'NEW_PASSWORD': "رمز عبور جدید",
		'NEW_PASSWORD_REPEAT': "تکرار رمز عبور جدید",
		'SAVE': "ذخیره",
		'TENANT_NAME': 'نام اشتراک',
		'CHANGE_TENANT': 'تغییر نام اشتراک',
		'NEXT_STEP': 'مرحله بعد',
	},
	'MENU': {
		'REGISTER': 'ثبت نام',
		'REGISTER_CONFIRM': 'تایید ثبت نام',
		'LOGIN': 'ورود',
		'DASHBOARD': 'داشبورد',
		'DYNAMIC': 'صفحات اختصاصی',
		'USEFULL_LINKS': 'لینک های مفید',
		'LIST': 'لیست',
		'NEW_RECORD': 'ایجاد',
		'LISTVIEW' : "لیست",
		'DETAILVIEW' : "مشاهده",
		'EDIT_VIEW': 'نمونه صفحه ویرایش',
		'FEATURES': 'قابلیت و المنت ها',
		'USER_SETTINGS': 'تنظیمات کاربر',
		
		'ACCOUNTS': 'مشتریان',
		'ACCOUNT_LIST': 'لیست مشتریان',
		'ACCOUNT_NEW': 'مشتری جدید',
		'ACCOUNT_EXIST': 'مشتری فعلی',

		'ASSETS': 'دستگاه',
		'ASSET_LIST': 'لیست دستگاه ها',
		'ASSET_NEW': 'دستگاه جدید',
		'ASSET_EXIST': 'دستگاه فعلی',

		'CASES': 'تیکت',
		'CASE_LIST': 'لیست تیکت ها',
		'CASE_NEW': 'تیکت جدید',
		'CASE_EXIST': 'تیکت فعلی',

		'CLAIMS': 'کلیم',
		'CLAIM_LIST': 'لیست کلیم ها',
		'CLAIM_NEW': 'کلیم جدید',
		'CLAIM_EXIST': 'کلیم فعلی',

		'CONTACTS': 'افراد',
		'CONTACT_LIST': 'لیست افراد',
		'CONTACT_NEW': 'فرد جدید',
		'CONTACT_EXIST': 'فرد فعلی',

		'CONTRACTS': 'قرارداد',
		'CONTRACT_LIST': 'لیست قرارداد ها',
		'CONTRACT_NEW': 'قرارداد جدید',
		'CONTRACT_EXIST': 'قرارداد فعلی',

		'CUSTOMER_CONSOLE': 'کنسول مشتری',

		'DEPOSITS': 'ودیعه',
		'DEPOSIT_LIST': 'لیست ودیعه ها',
		'DEPOSIT_NEW': 'ودیعه جدید',
		'DEPOSIT_EXIST': 'ودیعه فعلی',

		'INVOICES': 'فاکتور',
		'INVOICE_LIST': 'لیست فاکتور ها',
		'INVOICE_NEW': 'فاکتور جدید',
		'INVOICE_EXIST': 'فاکتور فعلی',

		'LEADS': 'سرنخ',
		'LEAD_LIST': 'لیست سرنخ ها',
		'LEAD_NEW': 'سرنخ جدید',
		'LEAD_EXIST': 'سرنخ فعلی',

		'OPPORTUNITIES': 'فرصت',
		'OPPORTUNITY_LIST': 'لیست فرصت ها',
		'OPPORTUNITY_NEW': 'فرصت جدید',
		'OPPORTUNITY_EXIST': 'فرصت فعلی',

		'PAYMENTS': 'پرداخت ها',
		'PAYMENT_LIST': 'لیست پرداخت ها',
		'PAYMENT_NEW': 'پرداخت جدید',
		'PAYMENT_EXIST': 'پرداخت فعلی',

		'ORDERS': 'سفارشات',
		'ORDER_LIST': 'لیست سفارشات',
		'ORDER_NEW': 'سفارش جدید',
		'ORDER_EXIST': 'سفارش فعلی',

		'WORK_ORDERS': 'دستورکار',
		'WORK_ORDER_LIST': 'لیست دستورکار ها',
		'WORK_ORDER_NEW': 'دستورکار جدید',
		'WORK_ORDER_EXIST': 'دستورکار فعلی',
		'LOG_OUT': 'خروج',
	},
	'CASES' : {
		'LBL_CASE_SELECT' : 'select',
		'LBL_CASE_FILE' : 'file',
		'LBL_CASE_SWITCH' : 'switch',
		'LBL_CASE_CHECKBOX' : 'checkbox',
		'LBL_CASE_CHECKBOX_LABEL' : 'checkbox label',
		'LBL_CASE_CHECKBOX_LABEL_SWITCH' : 'checkbox label switch',
		'LBL_CASE_RADIO' : 'radio',
		'LBL_CASE_TEXTAREA' : 'textarea',
		'LBL_CASE_DATE' : 'date',
		'LBL_CASE_TEXT' : 'text',

	},
	'DASHBOARD' : {
		'NEW_ANSWERS': 'پاسخ جدید',
		'SUCCESSFULL_PAYMENTS': 'پرداخت موفق',
		'INPROGRESS_CONTRACTS': 'قرارداد در حال اجرا',
		'UNPAID_INVOICES': 'فاکتور پرداخت نشده',
		'DETAILS': 'مشاهده جزئیات',
		'CASE_STATUS': 'تیکت های اخیر',
		'PAYMENT_STATUS': 'تراکنش های اخیر',
		'INVOICE_STATUS': 'نمودار وضعیت فاکتور ها',
	},
	'MODULES' : {
		'AOS_QUOTES' : 'پیش فاکتورها',
		'ASSETS' : 'دستگاه ها',
		'DOCUMENTS' : 'اسناد',
		'CALLS' : 'تماس ها',
		'OPPORTUNITIES' : 'فرصت ها',
		'AOS_INVOICES' : 'فاکتورها',
		'AOS_CONTRACTS' : 'قراردادها',
		'PURCHASE_ORDER' : 'سفارش خرید',
		'LEADS' : 'ُسرنخ ها',
		'CONTACTS' : 'افراد',
		'PAYMENTS' : 'پرداخت ها',
		'CASES' : 'سرویس ها',
		'WORK_ORDERS' : 'دستورکار',
		'PRODUCT_SAMPLES' : 'نمونه محصول',
		'ACCOUNTS' : 'حساب ها',
		'KNOWLEDGE_BASE' : 'مقالات',
	},
	'Assets' : {
		'LBL_ID' : 'شناسه',
		'LBL_ASSET' : 'دستگاه',
		'LBL_NAME' : 'عنوان',
		'LBL_STATUS' : 'وضعیت',
		'LBL_SERIAL_NUMBER' : 'شماره سریال',
		'LBL_DATE_MODIFIED' : 'آخرین به روزرسانی',
	},
	'GATEWAY' : {
		'LBL_PAY_INFORMATION' : 'جزئیات پرداخت',
		'LBL_ACCOUNT' : 'حساب',
		'LBL_AMOUNT_PAYABLE' : 'مبلغ قابل پرداخت',
		'LBL_CURRENCY_RIAL' : 'ریال',
		'LBL_SELECT_GATEWAY' : 'انتخاب درگاه پرداخت',
		'LBL_SAMAN_GATEWAY' : 'درگاه سامان کیش',
		'LBL_GATEWAY_DESCRIPTION': 'پرداخت با',
		'LBL_TRANSFER_TO_GATEWAY' : 'انتقال به درگاه پرداخت',
		'LBL_ALREADY_PAID': ' پرداخت شده ',
		'LBL_NOT_PAID': ' پرداخت نشده ',
		'LBL_SUCCESS_PAYMENT_STATUS': 'پرداخت شما با موفقیت انجام شد',
		'LBL_FAILED_PAYMENT_STATUS': 'خطایی هنگام پرداخت شما رخ داده است',
		'LBL_SUCCESS': 'موفق',
		'LBL_RETURN_TO_BACK' : 'بازگشت',
	}
};